export class VisibilityFlag{
    visibilityClickAndCollectSim: boolean;
    visibilityClickAndCollectSmartphone: boolean;
    visibilityEmail: boolean;
    visibilityEvent: boolean;
    visibilityFacebook: boolean;
    visibilityFullStoreDescription: boolean;
    visibilityGallery: boolean;
    visibilityGooglePlace: boolean;
    visibilityInternalGallery: boolean;
    visibilityManageOpeningClosingTime: boolean;
    visibilityManageOpeningClosingTimeAppointments: boolean;
    visibilityOpeningClosingTime: boolean;
    visibilityPromotion: boolean;
    visibilityScheduleAppointments: boolean;
    visibilityServices: boolean;
    visibilityStoreManager: boolean;
    visibilityStoreManagerEmail: boolean;
    visibilityStoreManagerPhoto: boolean;
    visibilityStoreManagerTelephone: boolean;
    visibilityTelephone: boolean;
    visibilityVideocallme: boolean;
    visibilityDigitalCoupon: boolean;
    visibilityClickAndCollectLightSim: boolean;
    constructor(){
        this.visibilityClickAndCollectSim = false;
        this.visibilityClickAndCollectSmartphone = false;
        this.visibilityEmail = false;
        this.visibilityEvent = false;
        this.visibilityFacebook = false;
        this.visibilityFullStoreDescription = false;
        this.visibilityGallery = false;
        this.visibilityGooglePlace = false;
        this.visibilityInternalGallery = false;
        this.visibilityManageOpeningClosingTime = false;
        this.visibilityManageOpeningClosingTimeAppointments = false;
        this.visibilityOpeningClosingTime = false;
        this.visibilityPromotion = false;
        this.visibilityScheduleAppointments = false;
        this.visibilityServices = false;
        this.visibilityStoreManager = false;
        this.visibilityStoreManagerEmail = false;
        this.visibilityStoreManagerPhoto = false;
        this.visibilityStoreManagerTelephone = false;
        this.visibilityTelephone = false;
        this.visibilityVideocallme = false;
        this.visibilityDigitalCoupon = false;
        this.visibilityClickAndCollectLightSim = false;
    }
}